import {
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  createStyles,
  Dialog,
  DialogActions,
  DialogContentText,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputBase,
  ListItemText,
  makeStyles,
  MenuItem,
  NativeSelect,
  Radio,
  RadioGroup,
  Select,
  Snackbar,
  Theme,
  Tooltip,
  Typography,
  withStyles,
} from "@material-ui/core";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Divider from "@material-ui/core/Divider";
import * as React from "react";
import { useEffect, useState } from "react";
import { primaryBlue, primaryGray, primaryRed, searchBarBorderColor, white } from "src/components/colors";
import { environment } from "src/environments/environment";
import ReactSwitch from "react-switch";
import { FileIcon, CloseIconColor, DownArrow, QuestionIcon, UpArrow, CloseIcon, AddIconTwo } from "../../../components/Icons";
import axios from "axios";
import { RemoteConfigComponent } from "./RemoteConfigComponent";
import AlertDialog from "src/components/AlertDialog";
import useStyles from "src/app/maintenance/assets/styles";
import { Alert } from "@material-ui/lab";
import { isStrictInteger, isCharValid, isNumeric, capitalizeWords } from "src/app/utils";
import { AuthService } from "src/app/authentication/auth.service";
import { addNewVersion, addSensor, getAllSensors } from "src/app/maintenance/test-automation/components/apiHelper";
import { AddSensors } from "src/app/setup-senzmatica/define-product-type-form/AddSensorComponent";
import { hasPackagePermission } from "src/app/authentication/package.permission";
import { Close } from "@material-ui/icons";
import { DropDownRMOTA } from "src/app/setup-senzmatica/step-3/components/DropDownRMOTA";
import { createParameter, editParameter, getDevicesOfVersion } from "src/app/auto-ml/utils/api";
import { AddCommands } from "src/app/setup-senzmatica/define-product-type-form/AddCommands";
import { ConfirmPopup } from "src/components/sub-components/ConfirmPopup";
import AddVersionBinFile from "src/app/setup-senzmatica/define-product-type-form/AddVersionBinFile";
import Cookies from "js-cookie";
import { getLatestVersion } from "./versionUtils";
export function EditRMOTA({
  productTypeRMOTAEdit,
  baseVersionNum,
  versionEdit,
  setVersionEdit,
  processJoinParameters,
  parameters,
  setParameters,
  updatedVersion,
  setUpdatedVersion,
  openEdit,
  updatedDataFormat,
  setUpdatedDataFormat,
  onClose,
  updatedRemotelyConfigurable,
  updatedOtaUpgradable,
  onUpdateSuccess,
  setUpdatedRemotelyConfigurable,
  setUpdatedOtaUpgradable,
  getAllProducts,
  intialParameters,
  lastVersion,
  setLastVersion,
  isVersionManagement
}) {
  const classes = useLocalStyles();
  const style = useStyles();
  const dataFormatOptions = ["String", "Json"];
  const inputTypeOptions = ["Text", "JSON", "HTML"];
  const formatOptions = ["String", "Integer", "Double", "Float", "Char"];
  const commandTypeOptions = ["Reset", "Restart", "Get_Config", "Other"];

  const [parametersAddedError, setParametersAddedError] = useState(false);
  const [addParameter, setAddParameter] = useState(false);
  const [mainType, setMainType] = useState(""); // network , topic or message
  const [type, setType] = useState("");
  const [index, setIndex] = useState(-1);

  const [addCommand, setAddCommand] = useState(false);
  const [tab, setTab] = useState("parameter");

  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("Successfully updated!")
  const [open, setOpen] = useState(false);
  const [reqSuccess, setReqSuccess] = useState(true);



  //parameter inputs
  const [parameter, setParameter] = useState("");
  const [id, setId] = useState("");
  const [inputType, setInputType] = useState("");
  const [defaultVal, setDefaultVal] = useState("");
  const [format, setFormat] = useState("");
  const [join, setJoin] = useState([]);
  const [commandType, setCommandType] = useState("");
  const [label, setLabel] = useState("");
  const [networkVisibility, setNetworkVisibility] = useState(false);
  const [topicVisibility, setTopicVisibility] = useState(false);
  const [messageVisibility, setMessageVisibility] = useState(false);

  const [formatError, setFormatError] = useState({ error: false, errorMsg: "" })
  const [inputTypeError, setInputTypeError] = useState({ error: false, errorMsg: "" });
  const [defaultValueError, setDefaultValueError] = useState({ error: false, errorMsg: "" });
  const [parameterError, setParameterError] = useState({
    error: false,
    errorMsg: "",
  });
  const [idError, setIdError] = useState({ error: false, errorMsg: "" });
  const [commandTypeError, setCommandTypeError] = useState({ error: false, errorMsg: "" });
  const [labelError, setLabelError] = useState({ error: false, errorMsg: "" })

  const [loadingScreen, setLoadingScreen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDialogSwitchTab, setOpenDialogSwitchTab] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [openPrompt, setOpenPrompt] = useState(false);
  const [isEditCurrentVersion, setIsEditCurrentVersion] = useState(true);
  const [binFile, setBinFile] = useState(null);
  const [binError, setBinError] = useState({ error: false, errorMsg: "" });
  const [productVersion, setProductVersion] = useState("");
  const [versionError, setVersionError] = useState({ error: false, errorMsg: "" })
  const [searchQuery, setSearchQuery] = useState('');
  const [majorVersionUpgrade, setMajorVersionUpgrade] = useState(false);

  const [isParamUpdated,setIsParamUpdated]=useState(false);
  const [errors, setErrors] = useState({
    dataFormatError: "",
    otaError: "",
    otaAckError: "",
    rmConfigError: "",
    rmAckError: "",
    binFileError: "",
    versionError: "",
  })
  const [topicError, setTopicError] = useState("");
  const [upgradePopup, setUpgradePopup] = useState({
    open: false,
    featureName: ''
  });

  //parameter options from backend
  const [allParameters, setAllParameters] = useState([]);
  const [parameterToCreate, setParameterToCreate] = useState(true);

  const [isInputTypeDropDown, setIsInputTypeDropDown] = useState(false);
  const [isFormatDropDown, setIsFormatDropDown] = useState(false);
  const [isCommandTypeDropdown, setIsCommandTypeDropdown] = useState(false);

  const [selectOption, setSelectOption] = useState({
    label: "",
    format: "",
    inputType: "",
    parameter: "",
    parameterId: ""
  }
  );
  const [parameterTemplateToEdit, setParameterTemplateToEdit] = useState({
    label: ""
  });
  const [parameterTemplateEdit, setParameterTemplateEdit] = useState(false);
  const [openEditParamLabel, setOpenParamLabel] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [confirmDialogDescription, setConfirmDialogDescription] = useState("");
  const [confirmDialogTitle, setConfirmDialogTitle] = useState("");
  const [deviceOfVersion, setDeviceOfVersion] = useState([]);


  const [updatedotaAckTopic, setupdatedotaAckTopic] = useState(productTypeRMOTAEdit.otaAckTopic || "");
  const [updatedrmAckTopic, setupdatedrmAckTopic] = useState(productTypeRMOTAEdit.remoteConfigAckTopic || "")
  const [updatedotaRequestTopic, setupdatedotaRequestTopic] = useState(productTypeRMOTAEdit.otaRequestTopic || "")
  const [updatedrmConfigTopic, setupdatedrmConfigTopic] = useState(productTypeRMOTAEdit.remoteConfigTopic || "");
  const [isEditBinFile, setIsEditBinfile] = useState(false);
  const [isAddVersion, setIsAddVersion] = useState(false);
  const [otaWithoutVersion, setotaWithoutVersion] = useState(false);  //keeping track if ota  toggled where version not yet added.
  const [rmwithoutVersion, setRmWithoutVersion] = useState(false);  //keeping track if  rm toggled where version not yet added.
  const [versionsNoParameters, setVersionsNoParameters] = useState(false);
  const [availableBinfiles, setAvailableBinFiles] = useState([]);
  const [isEditParamaters, setIsEditParameters] = useState(false);

  useEffect(() => {
    setIsEditBinfile(false);
    // console.log(updatedOtaUpgradable ,productTypeRMOTAEdit.versions == null , productTypeRMOTAEdit.versions.length == 0,!productTypeRMOTAEdit.versions.some(
    //     v => (v.binURL!=null)));
    if (updatedOtaUpgradable && (productTypeRMOTAEdit.versions == null || productTypeRMOTAEdit.versions.length == 0||!productTypeRMOTAEdit.versions.some(
        v => (v.binURL!=null) ))) {
      setIsAddVersion(true);
      setIsEditBinfile(true);
      setotaWithoutVersion(true);
      console.log('set to add versions')
    }
    if (updatedRemotelyConfigurable && (productTypeRMOTAEdit.versions == null || productTypeRMOTAEdit.versions.length == 0)) {
      setIsAddVersion(true);
      setIsEditParameters(true);
      setRmWithoutVersion(true);
      console.log('set to add versions')
    }
    if (updatedRemotelyConfigurable && productTypeRMOTAEdit.versions) {
      const hasAnyParameters = productTypeRMOTAEdit.versions.some(
        v => Array.isArray(v.remoteConfigurations) && v.remoteConfigurations.length > 0
      );
      if (!hasAnyParameters) {
        setVersionsNoParameters(true);
        setIsEditParameters(true);
        const lastVersiontToEdit=getLatestVersion(updatedVersion);
        setVersionEdit(lastVersiontToEdit);
        setLastVersion(lastVersiontToEdit);
        setIsEditCurrentVersion(true)
      }
    }
    setDeviceOfVersion([]);
    if (productTypeRMOTAEdit.productName) {
      const fetchDevicesCurrentversion = async () => {
        if(versionEdit && versionEdit.versionNum){
        const deviceOfVersion = await fetchDevicesOfVersion(productTypeRMOTAEdit.productName, versionEdit.versionNum);
        if ( deviceOfVersion) {
          setDeviceOfVersion(deviceOfVersion);
        }}
      }
      fetchDevicesCurrentversion();
    }
    if (updatedRemotelyConfigurable) {
      setupdatedrmAckTopic(productTypeRMOTAEdit.remoteConfigAckTopic || "");
      setupdatedrmConfigTopic(productTypeRMOTAEdit.remoteConfigTopic || "");
    } else {
      setupdatedrmAckTopic("");
      setupdatedrmConfigTopic("");
    }

    if (updatedOtaUpgradable) {
      setupdatedotaAckTopic(productTypeRMOTAEdit.otaAckTopic || "");
      setupdatedotaRequestTopic(productTypeRMOTAEdit.otaRequestTopic || "");
    } else {
      setupdatedotaAckTopic("");
      setupdatedotaRequestTopic("");
    }
    if(updatedOtaUpgradable&&updatedRemotelyConfigurable&&versionEdit.majorVersionUpgrade){
      setMajorVersionUpgrade(versionEdit.majorVersionUpgrade)
    }

    if (versionEdit &&lastVersion&& versionEdit.versionNum&&versionEdit.versionNum == lastVersion.versionNum) {
      setIsEditCurrentVersion(true);
      if(versionEdit.majorVersionUpgrade||(!updatedOtaUpgradable&&updatedRemotelyConfigurable)){
      setIsEditParameters(true)}
    }

  }, [productTypeRMOTAEdit]);

  const readMajorVersionUpgrade=(upgrade)=>{
    
    if(upgrade){
    setIsEditParameters(upgrade);
    setMajorVersionUpgrade(upgrade);
  }
    if(!upgrade){
      if(isParamUpdated){
        setConfirmDialogTitle("Discard Parameter changes?");
        setConfirmDialogDescription("Are you sure you want to discard the changes made to parameters?");
        setOpenConfirmDialog(true);
        
      }
      else{
        if(!versionsNoParameters&&!rmwithoutVersion){
          setIsEditParameters(false);
        }
         setMajorVersionUpgrade(upgrade);
      }
    }

  }
  // Fetch MetaData from the API endpoint
  //RM EDIT
  const openAddParameter = async (mainType, type, i) => {
    const parametersOptions = await getParameterOptions();
    setAllParameters(parametersOptions);
    setMainType(mainType);
    setType(type);
    setIndex(i);
    setAddParameter(true);
    if (type === "edit") {
      setInputType(parameters[i].inputType);
      setFormat(parameters[i].format);
      setJoin(parameters[i].joinParameter);
      setDefaultVal(parameters[i].defaultValue);
      setId(parameters[i].parameterId);
      setParameter(parameters[i].parameter);
      setLabel(parameters[i].label && parameters[i].label || "");
    }
  };

  const handleAdd = () => {
    setMajorVersionUpgrade(false);
    setIsEditParameters(false);
    setProductVersion("")
    setIsAddVersion(true);
    setIsEditBinfile(true);
    setIsEditCurrentVersion(false);
    let latest=getLatestVersion(productTypeRMOTAEdit.versions)
    setVersionEdit(latest);
    setParameters(latest.remoteConfigurations)

  }
  const handleCancelAddVersion = () => {
    setIsAddVersion(false);
    setIsEditBinfile(false);
    setBinFile(null);
    handleVersionChange(lastVersion);
    setIsEditCurrentVersion(true);

  }

  const closeAddParameter = () => {
    setType("");
    setAddParameter(false);
    setAddCommand(false);
    setParameter("");
    setId("");
    setInputType("");
    setLabel("")
    setDefaultVal("");
    setFormat("");
    setJoin([]);
    setParameterError({ error: false, errorMsg: "" });
    setCommandTypeError({ error: false, errorMsg: "" });
    setIdError({ error: false, errorMsg: "" });
    setDefaultValueError({ error: false, errorMsg: "" });
    setInputTypeError({ error: false, errorMsg: "" });
    setFormatError({ error: false, errorMsg: "" });
    // setMajorVersionUpgrade(false);

  };

  //VALIDATIONS

  const validateAddVersion = () => {
    let error: any = {}
    if ((binFile == null || undefined)) {
      error.binFileError = "bin file is required";
    }
    if ((productVersion.length == 0)) {
      error.versionError = "version number is required";
    }
    else if(!validateVersion(productVersion)){
      error.versionError = "version number is invalid";
    }
    else {
      const alreadyExists = productTypeRMOTAEdit.versions && productTypeRMOTAEdit.versions.some(
        (v) => v.versionNum === productVersion
      ); if (alreadyExists) {
        error.versionError = "Version number already available";
      }
    }

    return error;
  }
    useEffect(() => {
      if(updatedOtaUpgradable){
    axios.get(`${environment.host}/core/product/configDetails`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("ACCESS_TOKEN")}`,
      },
    })
      .then((response) => {
        if (response.data.content !== undefined) {
          let proTypes = [];

          // Access the array inside productTypes[0]
          response.data.content.productTypes[0].forEach((product) => {
            if (product.otaUpgradable === true) {
              proTypes.push(product.productName);
            }
          });        
          setAvailableBinFiles(response.data.content.availableBinFiles[0]); 
        }
      })
      .catch((err) => {
        console.error("Failed to fetch product types:", err);
      });}
  }, [updatedOtaUpgradable]);

  const validateConfigForm = () => {
    let error: any = {}

    if ((updatedOtaUpgradable || updatedRemotelyConfigurable) && updatedDataFormat.trim() === "") {
      error.dataFormatError = "Data Format is Required"
    }

    if (updatedRemotelyConfigurable && (!parameters || parameters.length === 0)) {
      error.parametersError = "Remote Config Parameters are Required";
    }
    if (updatedRemotelyConfigurable && (updatedrmConfigTopic.length === 0)) {
      error.rmConfigError = "Remote config  Topics are Required";
    }
    else if (updatedRemotelyConfigurable && !hasExactlyOnePlaceholderBySegment(updatedrmConfigTopic)) {
      error.rmConfigError = "Remote Topic must  have one {deviceId}";
    }
    if (updatedRemotelyConfigurable && (updatedrmAckTopic.length === 0)) {
      error.rmAckError = "Remote ack Topics are Required";
    }
    else if (updatedRemotelyConfigurable && !hasExactlyOnePlaceholderBySegment(updatedrmAckTopic)) {
      error.rmAckError = "Remote Topic must  have one {deviceId}";
    }
    if (updatedOtaUpgradable && (updatedotaRequestTopic.length === 0)) {
      error.otaError = "OTA Topics are Required";
    }
    else if (updatedOtaUpgradable&&!hasExactlyOnePlaceholderBySegment(updatedotaRequestTopic)) {
      error.otaError = "OTA Topic must have one {deviceId}";
    }
    if (updatedOtaUpgradable && (updatedotaAckTopic.length === 0)) {
      error.otaAckError = "OTA ack Topics are Required";
    }
    else if (updatedOtaUpgradable&&!hasExactlyOnePlaceholderBySegment(updatedotaAckTopic)) {
      error.otaAckError = "OTA Topic must have one {deviceId} ";
    }
    if (otaWithoutVersion && (binFile == null || undefined)) {
      error.binFileError = "bin file is required";
    }

    else if (binFile && binFile.name && availableBinfiles.some(name => name === binFile.name)) {
      error.binFileError = "File already availble with this filename";
    }


    if (rmwithoutVersion || otaWithoutVersion) {
      if (productVersion.length == 0) {
        error.versionError = "version number is required";
      }
      else if (!validateVersion(productVersion)) {
        error.versionError = "Invalid Version number";
      }
      else if  (isAddVersion){
         const alreadyExists = productTypeRMOTAEdit.versions && productTypeRMOTAEdit.versions.some(
        (v) => v.versionNum === productVersion
      ); if (alreadyExists) {
         error.versionError = "Version number already available";
      }
      }
    }
    if (rmwithoutVersion && parameters.length == 0) {
      setParametersAddedError(true);
    }
    if(versionsNoParameters&&parameters.length==0){
      setParametersAddedError(true);
    }
    return error

  }

const hasExactlyOnePlaceholderBySegment = (topic) => {
  const segments = topic.split("/");
  let deviceIdCount=0;

    for (const segment of segments) {
    if (segment === "{deviceId}") {
      deviceIdCount++;
    } else if (segment.includes("{") || segment.includes("}")) {
      return false; // any other placeholder is invalid
    }
  }

  return deviceIdCount === 1;
};
const validateVersion=(version)=>{
  console.log("version validate",version)
  return version.match("^(?!0+\\.0+\\.0+$)\\d+\\.\\d+\\.\\d+$");
}


  //read all input fields

  const readParameters = async (values) => {
    let formatMatchErrorCheck;
    if (type === "add-new") {
      let error;

      if (values.parameter === "" || values.parameterId === "" || values.inputType === "" || values.defaultValue === "" || values.format === ""||addParameter&&values.label===""||addCommand&&values.commandType==="") {
        error = true;
        if (addParameter&&values.parameter === "") {
          setParameterError({
            error: true,
            errorMsg: "Parameter Name is required",
          });
        }
        if (addCommand&&values.parameter === "") {
          setParameterError({
            error: true,
            errorMsg: "Command Name is required",
          });
        }
        if (values.defaultValue === "") {
          setDefaultValueError({ error: true, errorMsg: "Default value is required" });
        }
        if (values.inputType === "") {
          setInputTypeError({ error: true, errorMsg: "Input type is required" });
        }
        if (values.format === "") {
          setFormatError({ error: true, errorMsg: "Format is required" });
        }
        if (addParameter&&values.parameterId === "") {
          setIdError({ error: true, errorMsg: "Parameter Id is required" });
        }
        if (addCommand&&values.parameterId === "") {
          setIdError({ error: true, errorMsg: "command Id is required" });
        }
        if(addParameter&&values.label===""){
          setLabelError({ error: true, errorMsg: "Label is required" })
        }
        if(addCommand&&values.commandType===""){
          setCommandTypeError({ error: true, errorMsg: "CommandType is required" })
        }
        if (error === true) {
          return;
        }
      }

      formatMatchErrorCheck = validateDefaultValueFormat(values.format, values.defaultValue);
      if (!formatMatchErrorCheck) {
        return;
      };


      if (parameters.filter((obj) => obj.parameterId === values.parameterId).length > 0) {
        setIdError({ error: true, errorMsg: "parameter Id Already exist" });
        return;
      }
      //save as decimal if it is entered as integer.
      if ((values.format.toLowerCase() === "float" || values.format.toLowerCase() === "double") && isStrictInteger(values.defaultValue)) {
        const floatValue = parseFloat(values.defaultValue);
        const formatedFloatValue = floatValue.toFixed(1); // Ensure one decimal place 
        values.defaultValue = formatedFloatValue;
      }

      setDefaultValueError({ error: false, errorMsg: "" });
      if (addParameter && parameterToCreate) {
        let parameterCreate = {
          label: label,
          format: format,
          inputType: inputType,
          parameter: parameter,
          parameterId: id
        }
        try {
          setLoadingScreen(true);
          const response = await createParameter(parameterCreate);
          if (response.status && response.status === 200) {
            setReqSuccess(true);
            setSuccessMessage("Parameter label sucessfully added");

          } else {
            setReqSuccess(false);
            setErrorMessage("Error adding Parameter label");
            setOpen(true);
            return;
          }

          setOpen(true);
        } catch (err) {
          console.log("error catched", err)
          let message = "Error adding Parameter label";
          if (err.response && err.response.status === 422) {
            const errorData = err.response.data;
            if (errorData && errorData.message && errorData.message == "Data Already Exists") {
              message = "A parameter with the given label already exists"
            } else if (errorData && errorData.error && errorData.error.message) {
              message = errorData.error.message;
            }
          }
          setErrorMessage(message);
          setReqSuccess(false);
          setOpen(true);
          return;

        } finally {
          setLoadingScreen(false);
          setTimeout(() => {
            setOpen(false);
            setErrorMessage("");
          }, 6000);
        }
      }
      setIsParamUpdated(true);
      setParameters((current) => [...current, values]);
    }
    if (type === "edit" && index !== -1) {
      const keys = Object.keys(values);
      let error;
      if (values.parameter === "" || values.parameterId === "" || values.inputType === "" || values.defaultValue === "" || values.format === "") {
        error = true;
        if (values.parameter === "") {
          setParameterError({
            error: true,
            errorMsg: "Parameter Name is required",
          });
        }
        if (values.defaultValue === "") {
          setDefaultValueError({ error: true, errorMsg: "Default value is required" });
        }
        if (values.inputType === "") {
          setInputTypeError({ error: true, errorMsg: "Input type is required" });
        }
        if (values.format === "") {
          setFormatError({ error: true, errorMsg: "Format is required" });
        }
        if (values.parameterId === "") {
          setIdError({ error: true, errorMsg: "Parameter Id is required" });
        }
        if(addParameter&&values.label===""){
          setLabelError({ error: true, errorMsg: "Label is required" })
        }
        if(addCommand&&values.commandType===""){
          setCommandTypeError({ error: true, errorMsg: "CommandType is required" })
        }
        if (error == true) {
          return;
        }

      }
      formatMatchErrorCheck = validateDefaultValueFormat(values["format"], values["defaultValue"]);
      if (!formatMatchErrorCheck) { return; }
      if ((values.format.toLowerCase() === "float" || values.format.toLowerCase() === "double") && isStrictInteger(values.defaultValue)) {
        const floatValue = parseFloat(values.defaultValue);
        const formatedFloatValue = floatValue.toFixed(1); // Ensure one decimal place 
        values.defaultValue = formatedFloatValue;
      }
      keys.map((k) => {
        if (values[k] !== "") {
          parameters[index][k] = values[k];
        }
      });
      const paramTemplates = await getParameterOptions();
      const paramTemplateCurrent = paramTemplates.find(p => p.label === label);
      let isEdittedLabel = false;
      if (paramTemplateCurrent) {
        isEdittedLabel = paramTemplateCurrent.parameterId != id || paramTemplateCurrent.format != format || paramTemplateCurrent.inputType != inputType || paramTemplateCurrent.parameter != parameter
      }

      if (addParameter && isEdittedLabel) {
        let parameterEdit = {
          label: label,
          format: format,
          inputType: inputType,
          parameter: parameter,
          parameterId: id
        }
        setParameterTemplateToEdit(parameterEdit);
        setParameterTemplateEdit(true)
        setOpenParamLabel(true);
        if (!parameterTemplateEdit) {
          return;
        }
      }
      if (!paramTemplateCurrent && label.length > 0) {
        setLabelError({ error: true, errorMsg: "Label not Available" })
        return;
      }
      setDefaultValueError({ error: false, errorMsg: "" });
      setIsParamUpdated(true);
      setParameters(parameters);
      setType("");
    }
    setParameter("");
    setId("");
    setInputType("");
    setDefaultVal("");
    setFormat("");
    setJoin([]);
    setLabel("");
    if (addParameter) {
      setAddParameter(false);
    }
    if (addCommand) {
      setAddCommand(false);
      setCommandType("");
    }
    //setMajorVersionUpgrade(false);
  };


  const validateDefaultValueFormat = (format, defaultValue) => {
    let valid = true;
    format = format.toLowerCase();
    switch (format) {
      case "string":
        if (isNumeric(defaultValue)) {
          valid = false;
          setDefaultValueError({ error: true, errorMsg: "The input cannot be 'integer' only." })
        }
        break
      case "char":
        if (!isCharValid(defaultValue)) {
          valid = false;
          setDefaultValueError({ error: true, errorMsg: "Cannot add more than 1 character" })
        }
        break;
      case "double":
      case "float":
        if (!isNumeric(defaultValue)) {
          valid = false; // Must be numeric
          setDefaultValueError({ error: true, errorMsg: "Input must be a numeric value" })
        }
        break;
      case "integer":
        if (!isStrictInteger(defaultValue)) {

          valid = false; // Must be a valid integer
          setDefaultValueError({ error: true, errorMsg: "Input must be an integer" })
        }
        break;
      default:
        break;
    }

    return valid;
  }
  const openDeleteParameter = (i) => {
    setIndex(i)
    setOpenDelete(true);

  }
  const openAddCommand = (type, i) => {
    setAddCommand(true);
    setType(type);
    setIndex(i);
    setMainType("");


    if (type === "edit") {
      setInputType(parameters[i].inputType);
      setFormat(parameters[i].format);
      setDefaultVal(parameters[i].defaultValue);
      setId(parameters[i].parameterId);
      setParameter(parameters[i].parameter);
      setCommandType(parameters[i].commandType)
    }
  };
  const handleSwitchTab = (tabSelected) => {
    if (addCommand || addParameter) {
      setOpenDialogSwitchTab(true);
    }
    else {
      setTab(tabSelected)
    }

    setType("")
  }



  const handleCancelToggle = () => {
    setOpenConfirmDialog(false);
  }
  const handleDiscardParamChange=()=>{
    //reset parameters to last saved state
    if(versionEdit&&versionEdit.remoteConfigurations){
      setParameters(versionEdit.remoteConfigurations);
    }
    if(!versionsNoParameters&&!rmwithoutVersion){
    setIsEditParameters(false);}
    setOpenConfirmDialog(false);
    setMajorVersionUpgrade(false);
  }
  const handleCloseParamLabelEdit = () => {
    setOpenParamLabel(false);
  }
  const handleConfirmEditParamLabel = async () => {
    setLoadingScreen(true);
    try {
      const response = await editParameter(parameterTemplateToEdit.label, parameterTemplateToEdit);
      if (response.status && response.status === 200) {
        setReqSuccess(true);
        setErrorMessage("Parameter label sucessfully updated");
        setOpen(true);
        setParameterTemplateEdit(true);
        setOpenParamLabel(false);

      } else {
        console.log(response)
        setReqSuccess(false);
        setErrorMessage("Error editing Parameter label");
        setParameterToCreate(false);
        setOpen(true);

        return;
      }

    } catch (err) {
      console.log("error catched", err)
      setReqSuccess(false);
      setParameterToCreate(false);
      setErrorMessage("Error editing Parameter label");
      setOpen(true);
      return;

    } finally {
      setTimeout(() => {
        setLoadingScreen(false);
        setOpen(false)
      }, 2000);
    }

  }
  const handleVersionChange = async (version) => {
    setLoadingScreen(true);
    const deviceOfVersion = await fetchDevicesOfVersion(productTypeRMOTAEdit.productName, version.versionNum);
    if (deviceOfVersion) {
      setDeviceOfVersion(deviceOfVersion);
    }
    updateVersionParams();
    const versionToEdit = version
      setIsEditBinfile(false);
      setIsAddVersion(false);
    processJoinParameters(versionToEdit.joinParameters, versionToEdit.remoteConfigurations);
    setVersionEdit(versionToEdit);
    const majorVersionUpdate=versionToEdit.majorVersionUpgrade||false;
    console.log(versionToEdit,majorVersionUpdate)
    setMajorVersionUpgrade(majorVersionUpdate)
    if (versionToEdit.versionNum == lastVersion.versionNum) {
      setIsEditCurrentVersion(true);
      if(majorVersionUpdate){
        setIsEditParameters(true);
      }
      else{setIsEditParameters(false);}
    }
    else {
      setIsEditCurrentVersion(false);
      setIsEditParameters(false);

    }
    setParameters(versionToEdit.remoteConfigurations);
    setLoadingScreen(false);
    console.log('version changed',versionToEdit,lastVersion,isAddVersion,isEditCurrentVersion,majorVersionUpdate,otaWithoutVersion,rmwithoutVersion,versionsNoParameters)
  }

  const handleDiscardTab = () => {
    closeAddParameter();
    if (tab === 'parameter') {
      setTab('command')
    }
    else if (tab === 'command') {
      setTab('parameter')
    }
    setOpenDialogSwitchTab(false);
  }
  const handleDeleteParameter = () => {
    deleteParameter(index);
  }
  const deleteParameter = (indexToDelete) => {
    let parameterIdToDelete = parameters[indexToDelete].parameterId;
    let updatedParams = parameters;

    parameters.forEach(parameter => {
      if (parameter.parameterId !== parameterIdToDelete && parameter.joinParameter && parameter.joinParameter.includes(parameterIdToDelete)) {
        const updatedJoinParameter = parameter.joinParameter.filter(i => i != parameterIdToDelete)
        updatedParams = updatedParams.map(p => p.parameterId == parameter.parameterId ? { ...p, joinParameter: updatedJoinParameter } : p);
      }
    })

    const updatedParamList = updatedParams.filter(p => p.parameterId !== parameterIdToDelete);
    setParameters(updatedParamList);
    setIndex(-1);
    setOpenDelete(false);
  }
  const openNetworkVisibility = () => {
    setNetworkVisibility(!networkVisibility);
  };
  const openTopicVisibility = () => {
    setTopicVisibility(!topicVisibility);
  };
  const openMessageVisibility = () => {
    setMessageVisibility(!messageVisibility);
  };



  const selectJoin = (e) => {
    setJoin(e.target.value);
  };
  const removeJoin = (value) => {
    setJoin(join.filter((d) => d !== value));
  };

  const updateVersionParams = () => {
    if ((isEditCurrentVersion||isAddVersion)) {
      //move join as dependencyMap
      let editedLastVersionDetails;
      const dependencyMap = new Map();
      parameters.forEach(param => {
        const paramId = param.parameterId;
        const joinParameters = param.joinParameter || []

        joinParameters.forEach(joinParamId => {
          if (!dependencyMap.has(joinParamId)) {
            dependencyMap.set(joinParamId, []);
          }
          if (!dependencyMap.get(joinParamId).includes(paramId)) {
            dependencyMap.get(joinParamId).push(paramId);
          }

          if (!dependencyMap.has(paramId)) {
            dependencyMap.set(paramId, []);
          }
          if (!dependencyMap.get(paramId).includes(joinParamId)) {
            dependencyMap.get(paramId).push(joinParamId);
          }
        });

        delete param.joinParameter; //delete this and update parmaters with .map(({ joinParameter, ...rest }) => rest) 
      });

      if (isAddVersion) {
        if (binFile) {
          return [{
            versionNum: productVersion,
            fileName: binFile.name,
            remoteConfigurations: updatedRemotelyConfigurable?parameters:[],
            majorVersionUpgrade:majorVersionUpgrade,
            joinParameters: updatedRemotelyConfigurable?dependencyMap:{}
          }]
        }
        else if (rmwithoutVersion) {
          return [{
            versionNum: productVersion,
            remoteConfigurations: parameters,
            joinParameters: dependencyMap
          }]
        }
        
      }
      let versionFound;
      editedLastVersionDetails = {
        ...lastVersion, remoteConfigurations: parameters,
        joinParameters: dependencyMap,majorVersionUpgrade:majorVersionUpgrade
      }
      console.log('sent Version to edit',editedLastVersionDetails)
      setLastVersion(editedLastVersionDetails);
      let updateVersionList = updatedVersion.map((version, index) => {
        if (version.versionNum === versionEdit.versionNum) {
          versionFound = true;
          return {
            ...version,
            remoteConfigurations: parameters,
            joinParameters: dependencyMap,
            majorVersionUpgrade:majorVersionUpgrade
          };

        }
        return version;
      });

      if (!versionFound && updatedRemotelyConfigurable && isEditCurrentVersion) {
        updateVersionList.push({ versionNum: "0.0.0", remoteConfigurations: parameters, joinParameters: dependencyMap });
      }

      setUpdatedVersion(updateVersionList);

      return isParamUpdated?[editedLastVersionDetails]:[];
    }
    return [];
  }


  //API endpoint for the update product type
  const updateProductType = async () => {
    try {
      const accessToken = AuthService.getAccessToken();

      const versionListUpdated = updateVersionParams();


      const updatedData =
      {
        id: productTypeRMOTAEdit.id,
        productName: productTypeRMOTAEdit.productName,
        otaUpgradable: updatedOtaUpgradable ? true : false,
        remotelyConfigurable: updatedRemotelyConfigurable ? true : false,
        dataFormat: updatedDataFormat,
        ...((updatedRemotelyConfigurable || updatedOtaUpgradable) && { versions: versionListUpdated }),
        ...(updatedRemotelyConfigurable && {
          remoteConfigTopic: updatedrmConfigTopic,
          remoteConfigAckTopic: updatedrmAckTopic
        }),
        ...(updatedOtaUpgradable && {
          otaAckTopic: updatedotaAckTopic,
          otaRequestTopic: updatedotaRequestTopic
        })
        //TODO add bin file if available with filename 

      };

      console.log(updatedData);
      const formData = new FormData();
      const jsonBlob = new Blob([JSON.stringify(updatedData)], { type: "application/json" });
      formData.append("productTypeDTO", jsonBlob);

      if (binFile ) {
        formData.append("binFile", binFile);
      }

      setLoadingScreen(true);
      const response = await axios.put(`${environment.host}/core/user/${AuthService.getUserId()}/product/productType/${productTypeRMOTAEdit.id}/Config`, formData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })

      const updatedProductType = response.data;

      if (response.data.errorCode && response.data.errorCode.length > 0) {

        setReqSuccess(false);
        setOpen(true);
        setErrorMessage(response.data.message);
        setLoadingScreen(false);
        setTimeout(() => {
          setOpen(false);
          setErrorMessage("");
        }, 6000);
      } else {
        setReqSuccess(true);
        setSuccessMessage("Configurations of Product Type Updated Successfully")
        setLoadingScreen(false);

        if (onUpdateSuccess) {
          onUpdateSuccess("Configurations of Product Type updated Successfully");
        }

        await getAllProducts();
        clearFormFields();
        onClose();
      }

    }
    catch (error) {
      console.error('Error updating Configurations of Product Type :', error);
      setLoadingScreen(false);
      throw error;
    };
  };


  const handleDataFormatChange = (event) => {
    setUpdatedDataFormat(event.target.value);
  };
  const CancelUpdate=()=>{
    clearFormFields();
    onClose();
  }
  const clearFormFields=()=>{
    setErrors(    
    {dataFormatError: "",
    otaError: "",
    otaAckError: "",
    rmConfigError: "",
    rmAckError: "",
    binFileError: "",
    versionError: "",});
    setParametersAddedError(false);
    setIsEditParameters(false);
    setIsAddVersion(false);
    setIsEditCurrentVersion(false);
    setRmWithoutVersion(false);
    setotaWithoutVersion(false);
    setVersionsNoParameters(false);
    setMajorVersionUpgrade(false);
    setParameters([]);
    setProductVersion("");
    setBinFile(null);



  }




  const handleAddVersion = async () => {
    const validationError = validateAddVersion();
    console.log(validationError);
    setErrors(validationError);
    if (Object.keys(validationError).length > 0) {
      return;
    }
    const versionListUpdated = updateVersionParams();
    console.log("verion u[pdated list", versionListUpdated)
    const formData = new FormData();
    formData.append("binFile", binFile);
    const updatedVersion = versionListUpdated[0];

    console.log('version', updatedVersion);
    const versionToAdd = { ...updatedVersion, versionNum: productVersion, fileName: binFile.name };
    console.log(versionToAdd)
    formData.append("version", JSON.stringify(versionToAdd));

    const response = await axios.post(`${environment.host}/core/user/${Cookies.get("USER_ID")}/product/${productTypeRMOTAEdit.id}`, formData, {
      headers: {
        Authorization: `Bearer ${Cookies.get("ACCESS_TOKEN")}`,
      },
    })
      .then((response) => {
        if (response.status = 200) {
          setIsAddVersion(false);
          setIsEditBinfile(false);
          setBinFile(null);
          let latest = getLatestVersion(response.data.content.versions);
          setLastVersion(latest);
          setReqSuccess(true);
          setOpen(true);
          setTimeout(() => {
            setOpen(false);
            setErrorMessage("");
          }, 6000);
          setUpdatedVersion(response.data.content.versions);
          setLastVersion(latest);
          handleVersionChange(latest);
        }
        else{
          setReqSuccess(false);
          setOpen(true);
          let errorMsg="Failed to add versions";
          if(response.status==422){
                 errorMsg=response.data&&response.data.error&&response.data.error.message||"Failed to add versions";
          }
          setTimeout(() => {
            setOpen(false);
            setErrorMessage(errorMsg);
          }, 6000);
    

        }
        
      })
      .catch((err) => {
        console.log(err);
          setReqSuccess(false);
          setOpen(true);
          let errorMsg="Failed to add version";
          setTimeout(() => {
            setOpen(false);
            setErrorMessage(errorMsg);
          }, 6000);
    
      });


  }

  const handleSave = async () => {
    const validationError = validateConfigForm();
    console.log(validationError);
    setErrors(validationError)
    if (Object.keys(validationError).length > 0) {
      return;
    }


    try {
      await updateProductType();
      setIsAddVersion(false);
      setotaWithoutVersion(false);
      setIsEditBinfile(false);
      setProductVersion("");
      setRmWithoutVersion(false);
      setVersionsNoParameters(false);
      setupdatedotaRequestTopic("");
      setupdatedrmConfigTopic("");
      setUpdatedDataFormat("");
      setupdatedotaAckTopic("");
      setupdatedrmConfigTopic("");
      setIsEditCurrentVersion(false);
      setParameters([]);

    } catch (error) {
      console.error('Error updating product type:', error);
      setReqSuccess(false);
      setOpen(true);
      if (error.response.data.message) {
        setErrorMessage(error.response.data.message);
      }
      setTimeout(() => {
        setOpen(false);
        setErrorMessage("");
      }, 6000);
    }
  };
  const getParameterOptions = async () => {
    try {
      setLoadingScreen(true)
      const response = await axios.get(`${environment.host}/core/remoteParameter`);
      const content = response.data && response.data.content ? response.data.content : [];
      setLoadingScreen(false);
      setAllParameters(content);
      return content;
    } catch (error) {
      console.error('Failed to fetch parameter options:', error);
      setLoadingScreen(false);
      return [];
    }
  };
  const fetchDevicesOfVersion = async (product, version) => {
    try {
      const response = await getDevicesOfVersion(product, version);
      const content = response.data && response.data.content ? response.data.content : [];
      return content;
    }
    catch (err) {
      setReqSuccess(false);
      setParameterToCreate(false);
      setErrorMessage("Error getting Devices");
      setOpen(true);
      setTimeout(() => {
        setLoadingScreen(false);
        setOpen(false)
      }, 2000);
      return;
    }
    finally {
      setLoadingScreen(false);
    }
  };
  const handleParameterSelect = (value) => {
    setSelectOption(value);
    setParameter(value.parameter);
    setInputType(value.inputType);
    setFormat(value.format);
    setLabel(value.label);
    setId(value.parameterId);
    setParameterToCreate(false);
    setParameterError({ error: false, errorMsg: "" });
    setIdError({ error: false, errorMsg: "" });
    setInputTypeError({ error: false, errorMsg: "" });
    setFormatError({ error: false, errorMsg: "" });
    setLabelError({ error: false, errorMsg: "" });

  }
  const handleParameterCreate = (parameter, isCreate) => {
    setParameter(parameter);
    setParameterToCreate(isCreate);
  }
  const handleCommandTypeSelect = (value) => {
    setCommandType(value);
    setCommandTypeError({ error: false, errorMsg: "" });
  }
    const handleFormatSelect = (value) => {
    setFormat(value);
    setFormatError({ error: false, errorMsg: "" });
  }
  const handleInputTypeSelect = (value) => {
    setInputType(value);
    setInputTypeError({ error: false, errorMsg: "" });
  }

  const UpgradePopup = ({
    open,
    onClose,
    onUpgrade,
    featureName,
    onCloseWithFeature
  }) => {
    return (
      <Dialog
        open={open}
        onClose={onClose}
        PaperProps={{
          style: {
            width: '650px',
            maxWidth: '80%',
          },
        }}
      >
        <DialogTitle>
          <Grid container justifyContent="flex-end" alignItems="center">
            <IconButton onClick={onClose} size="small">
              <Close />
            </IconButton>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" style={{ marginBottom: '15px' }}>
            You've just configured a feature available only in the Basic package. To perform {featureName} operations, please upgrade your plan.
          </Typography>
          <Grid container justifyContent="flex-end" spacing={1}>
            <Grid item>
              <Button
                variant="contained"
                onClick={onUpgrade}
                className={style.buttonContained}
                style={{ backgroundColor: '#2A7CED', color: '#FFFFFF' }}
              >
                Upgrade Now
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                onClick={onCloseWithFeature}
                className={style.buttonOutlined}
              >
                OK
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    );
  };


  const handleClose = (event: {}, reason: 'backdropClick' | 'escapeKeyDown') => {
    if (reason === 'backdropClick') {
      return; // to avoid closing popup during  backdrop click 
    }
    setupdatedotaRequestTopic("");
    setupdatedrmConfigTopic("");
    setUpdatedDataFormat("");
    setupdatedotaAckTopic("");
    setupdatedrmConfigTopic("");
    setIsEditBinfile(false);
    setIsAddVersion(false);
    setIsEditCurrentVersion(false);
    setParameters([]);
    onClose();
  };
  return (
    <div>
      <Dialog
        open={openEdit}
        onClose={handleClose}
        fullWidth={true}
        maxWidth={"md"}
        BackdropProps={{
          style: {
            backgroundColor: "cubic-bezier(0.4, 0, 0.1, 1)",
            opacity: "0.2",
          },
        }}
        PaperProps={{
          style: {
            boxShadow: "inherit",
            width: "80%",
            minWidth: "600px"
          },
        }}
      >
        <Grid
          container
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            opacity: "1",
            boxShadow: '0px 4px 40px rgba(0, 0, 0, 0.08)',
          }}
        >
          <Grid item xs={10} md={10}>
            <DialogTitle>Version Management - {productTypeRMOTAEdit.productName}</DialogTitle>
          </Grid>
          <Grid item xs={2} md={2} style={{ textAlign: "right" }}>
            <IconButton
              onClick={CancelUpdate} >
              <CloseIconColor />
            </IconButton>
          </Grid>
        </Grid>
        <>
          <DialogContent>
            <Grid container alignItems="center" justifyContent="center">

              {(updatedRemotelyConfigurable) &&
                <Grid container alignItems="center" justifyContent="center">
                  <Grid item xs={6} md={6}
                    className={classes.gridStyle}
                  >
                    <Typography className={`${classes.labelStyle} ${type === "view" ? classes.greyLabel : ''}`}>
                      Remote Config Topic:
                    </Typography>

                    <FormControl className={style.input}>
                      <input
                        className={style.formInputNew}
                        disabled={type === "view"}
                        onChange={(e) => {
                          setupdatedrmConfigTopic(e.target.value);
                        }}
                        value={
                          updatedrmConfigTopic
                        }
                        placeholder="../sampleTopic/{deviceId}/.."
                      />
                    </FormControl>
                    {errors.rmConfigError && errors.rmConfigError.length > 0 && (
                      <Typography className={style.errorText}>
                        {errors.rmConfigError}</Typography>
                    )}
                  </Grid>
                  <Grid item xs={6} md={6}
                    className={classes.gridStyle}
                  >
                    <Typography className={`${classes.labelStyle} ${type === "view" ? classes.greyLabel : ''}`}>
                      Remote Config Ack Topic:
                    </Typography>
                    <FormControl className={style.input}>
                      <input
                        className={style.formInputNew}
                        disabled={type === "view"}
                        onChange={(e) => {
                          setupdatedrmAckTopic(e.target.value);
                        }}
                        value={
                          updatedrmAckTopic
                        }
                        placeholder="../sampleTopic/{deviceId}/.."
                      />
                    </FormControl>
                    {errors.rmAckError && errors.rmAckError.length > 0 && (
                      <Typography className={style.errorText}>
                        {errors.rmAckError}</Typography>
                    )}
                  </Grid>
                </Grid>}
              {(updatedOtaUpgradable) &&
                <Grid container alignItems="center" justifyContent="center">
                  <Grid item xs={6} md={6}
                    className={classes.gridStyle}
                  >
                    <Typography className={`${classes.labelStyle} ${type === "view" ? classes.greyLabel : ''}`}>
                      OTA Config Topic:
                    </Typography>
                    <FormControl className={style.input}>
                      <input
                        className={style.formInputNew}
                        onChange={(e) => {
                          setupdatedotaRequestTopic(e.target.value);
                        }}
                        value={
                          updatedotaRequestTopic
                        }
                        placeholder="../sampleTopic/{deviceId}/.."
                      />
                    </FormControl>
                    {errors.otaError && errors.otaError.length > 0 && (
                      <Typography className={style.errorText}>
                        {errors.otaError}</Typography>
                    )}
                  </Grid>
                  <Grid item xs={6} md={6}
                    className={classes.gridStyle}
                  >
                    <Typography className={`${classes.labelStyle} ${type === "view" ? classes.greyLabel : ''}`}>
                      OTA Config Ack Topic:
                    </Typography>

                    <FormControl className={style.input}>
                      <input
                        className={style.formInputNew}
                        disabled={type === "view"}
                        onChange={(e) => {
                          setupdatedotaAckTopic(e.target.value);
                        }}
                        value={
                          updatedotaAckTopic
                        }
                        placeholder="../sampleTopic/{deviceId}"
                      />
                    </FormControl>
                    {errors.otaAckError && errors.otaAckError.length > 0 && (
                      <Typography className={style.errorText}>
                        {errors.otaAckError}</Typography>
                    )}
                  </Grid>
                </Grid>}

              <Grid container style={{ justifyContent: "space-between" }}>
                <Grid item xs={12} md={12} className={classes.gridStyle} >
                  <Typography className={classes.labelStyle}>
                    Data Format :
                  </Typography>
                  <FormControl className={style.input}>
                    <select
                      className={style.formInputNew}
                      value={updatedDataFormat}
                      onChange={handleDataFormatChange}
                    >
                      <option value={updatedDataFormat}>{updatedDataFormat}</option>
                      {updatedDataFormat !== "String" && <option value="String">String</option>}
                      {updatedDataFormat !== "Json" && <option value="Json">Json</option>}
                    </select>
                  </FormControl>
                  {errors.dataFormatError && (
                    <span className="form-error">
                      {errors.dataFormatError}
                    </span>
                  )}
                </Grid>
                {/* <Grid item xs={5} md={5} className={classes.gridStyle} style={{display:"flex",justifyContent:"flex-end",alignItems:"flex-end"}}>
                    <Button
                      variant="contained"
                      onClick={toggleDeviceView}
                      className={classes.configDevicesButton}
                      style={{ textTransform: "none" }}
                    >
                      Configure Devices

                      <ArrowIcon width="20" height="15" />

                    </Button>
                  </Grid> */}
              </Grid>




              <>
                {(!otaWithoutVersion &&!rmwithoutVersion) &&!isAddVersion&& (
                  <Grid container >
                    <Grid item xs={12}>
                      <Typography
                        className={style.inputLabel}
                      >
                        Version
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs
                      style={{
                        textAlign: "left",
                        marginBottom: "22px",
                        paddingRight: "2%",
                        marginRight: "0px",
                        width:  `${!versionsNoParameters?'calc(100% - 200px)':"100%"}`
                      }}

                    >


                      <DropDownRMOTA
                        options={updatedVersion}
                        type="versionEdit"
                        onClick={(version) => {
                          handleVersionChange(version);
                        }}
                        value={versionEdit}
                        isSingle={true} />
                    </Grid>
                   {isVersionManagement&&
                    <Grid item style={{ width: "180px" }}>
                      <Button
                        variant="contained"
                        className={style.buttonWhiteBack}
                        style={{ textTransform: "none" }}
                        onClick={handleAdd}
                        disabled={!updatedOtaUpgradable || otaWithoutVersion}
                      >
                        <AddIconTwo color={primaryBlue} />
                        <Typography>Add New version</Typography>
                      </Button>
                    </Grid>}

                  </Grid>)}

                <Grid item style={{
                  boxSizing: "border-box",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "16px 20px 20px",
                  background: "#F4F5F7",
                  border: "1px solid #E2E5ED",
                  borderRadius: " 0px 0px 8px 8px",
                  width: "100%",
                  gap: "11px"
                }}>
                  {(!otaWithoutVersion && !rmwithoutVersion && versionEdit && versionEdit.versionNum&&!isAddVersion) && (
                    <>
                      <Typography
                        style={{
                          fontFamily: "Poppins",
                          fontWeight: "normal",
                          fontStyle: "normal",
                          fontSize: "16px",
                          lineHeight: "25px",
                          color: primaryGray,
                          width: "100%"
                        }}
                      >
                        Devices
                      </Typography>
                      <Grid container style={{
                        justifyContent: "flex-start", display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "12px",
                        boxSizing: "border-box",
                        background: "#FFFFFF",
                        border: "0.5px solid #C7C4C4",
                        borderRadius: "4px",
                        padding: "10px"

                      }}>
                        {versionEdit && versionEdit.versionNum && deviceOfVersion && deviceOfVersion.length > 0 ? deviceOfVersion.map((d) => (
                          <DeviceListItem
                            key={d.id}
                            deviceName={d.name}
                            styles={classes}
                          />
                        )) : <p className={classes.deviceLeft}>No devices available on this version</p>}
                      </Grid></>)}
                  {isAddVersion && (
                    <>
                      {/*//   updatedOtaUpgradable&&
                    // <Grid
                    //         item
                    //         xs={12}
                    //         md={12}
                    //         style={{
                    //           textAlign: "left",
                    //           marginBottom: "20px",
                    //           display: "flex",
                    //           alignItems: "center",
                    //         }}
                    //       >
                    //         <Typography className={style.label}>Major Version Upgrade</Typography>
                    //         <FormControlLabel
                    //           label={""}
                    //           control={
                    //             <Checkbox
                    //               className={classes.input}
                    //               checked={majorVersionUpgrade}
                    //               style={{padding: "0px"}}
                    //               onChange={(e) => {
                    //                 readMajorVersionUpgrade(e.target.checked);
                    //               }}
                    //               color="primary"
                    //               inputProps={{
                    //                 "aria-label": "primary checkbox",
                    //               }}
                    //             />
                    //           }
                    //           labelPlacement="start"
                    //         />
                    //       </Grid>} */}
                      < Grid container style={{ marginBottom: "20px" }} >
                        <Grid item xs={12} md={12}>
                          <Typography className={style.typo}>
                            Version number
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={12}>
                          <Grid container alignItems="center"  >
                            <Grid item xs={12} md={12}>
                              <FormControl className={style.input}>
                                <input
                                  className={style.formInputNew}
                                  type="text"
                                  placeholder="Enter Version Here"
                                  value={productVersion}
                                  onChange={(e) => {
                                    setProductVersion(e.target.value);
                                    setErrors({ ...errors, versionError: "" })
                                  }}
                                />
                              </FormControl>
                              {errors.versionError && errors.versionError.length > 0 && (
                                <Typography className={style.errorText}>
                                  {errors.versionError}</Typography>
                              )}
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid></>)}
                      {updatedOtaUpgradable&&updatedRemotelyConfigurable&& versionEdit&&(versionEdit.fileName||isEditBinFile)&&   <Grid
        item
        xs={12}
        md={12}
        style={{
          textAlign: "left",
          display: "flex",
          alignItems: "center",
          width:"100%"
          
        }}
      >
        <Typography className={style.inputLabel}>Major Version Upgrade</Typography>
        <FormControlLabel
          label={""}
          control={
            <Checkbox
              className={classes.input}
              checked={majorVersionUpgrade}
              style={{padding: "0px"}}
              onChange={(e) => {
                readMajorVersionUpgrade(e.target.checked);
              }}
              color="primary"
              disabled={!isEditCurrentVersion&&!isAddVersion}
              inputProps={{
                "aria-label": "primary checkbox",
              }}
            />
          }
          labelPlacement="start"
        />
      </Grid>}
                  {updatedOtaUpgradable && ((versionEdit && versionEdit.fileName) || isEditBinFile) && (
                    <Typography
                      style={{
                        fontFamily: "Poppins",
                        fontWeight: "normal",
                        fontStyle: "normal",
                        fontSize: "16px",
                        lineHeight: "25px",
                        color: primaryGray,
                        width: "100%"
                      }}
                    >
                      Bin File
                    </Typography>)}
                  {updatedOtaUpgradable && !isEditBinFile && versionEdit && versionEdit.fileName && (
                    <Grid container className={classes.shadowedbox}>
                      <Grid item className={classes.fileContainer}><div className={classes.fileContent}><FileIcon /><p style={{ maxWidth: "80%", textOverflow: "ellipsis", overflow: "hidden" }} >{updatedOtaUpgradable && versionEdit && versionEdit.fileName}</p></div>{isEditCurrentVersion && <IconButton style={{ padding: "2px", display: "flex", alignItems: "center" }} onClick={() => { setIsEditBinfile(true) }} ><CloseIcon color="red" /></IconButton>}
                      </Grid>
                    </Grid>)}
                  {updatedOtaUpgradable && isEditBinFile && (
                    <>

                      <AddVersionBinFile
                        setBinFile={(file)=>{setBinFile(file);setIsParamUpdated(true)}}
                        binError={binError} setBinError={setBinError}
                        setReqSuccess={setReqSuccess} setErrorMessage={setErrorMessage} setToaster={setOpen} />
                      {errors.binFileError && errors.binFileError.length > 0 && (
                        <Typography className={style.errorText}>
                          {errors.binFileError}</Typography>
                      )}
                    </>)}


                  {updatedRemotelyConfigurable && (versionEdit && versionEdit.versionNum || isAddVersion) &&(parameters.length>0||isEditCurrentVersion||isAddVersion) &&(

                    <>
                      <Grid container>
                        <Grid item xs={6} md={6}
                          onClick={() => handleSwitchTab('parameter')}
                          className={`${style.formInput} ${style.switchTab}`}
                          style={{
                            borderBottom: tab == "parameter" ? '3px solid #2A7CED' : '1px solid #ccc'
                          }}>
                          <div>Parameters</div>
                        </Grid>
                        <Grid item xs={6} md={6}
                          onClick={() => handleSwitchTab('command')}
                          className={`${style.formInput} ${style.switchTab}`}
                          style={{
                            borderBottom: tab == "command" ? '3px solid #2A7CED' : '1px solid #ccc', padding: "5px"
                          }}>
                          <div>Commands</div>
                        </Grid>

                      </Grid>
                      {tab == "parameter" ?
                        <Grid item xs={12} md={12} style={{ width: "100%" }}>
                          <RemoteConfigComponent
                            openNetworkVisibility={() => openNetworkVisibility()}
                            openTopicVisibility={() => openTopicVisibility()}
                            openMessageVisibility={() => openMessageVisibility()}
                            networkVisibility={networkVisibility}
                            topicVisibility={topicVisibility}
                            messageVisibility={messageVisibility}
                            open={(mainType, type, i) => {
                              if (type == "delete") {
                                openDeleteParameter(i);
                              }
                              else {
                                openAddParameter(mainType, type, i)
                              }
                            }
                            }
                            parameters={parameters}
                            intialParameters={intialParameters}
                            setParameters={setParameters}
                            productType={productTypeRMOTAEdit.productName}

                            readParameters={(parameters) => readParameters(parameters)}
                            parametersAddedError={parametersAddedError}

                            remotelyConfigurable={updatedRemotelyConfigurable}
                            editparameterfields={isEditParamaters}
                          />
                        </Grid> :

                        (<Grid container>
                          <AddCommands
                            open={(type, i) =>
                              openAddCommand(type, i)
                            }
                            parameters={parameters}
                            readParameters={(parameters) => readParameters(parameters)}
                            parametersAddedError={parametersAddedError}
                            deleteParameter={deleteParameter}
                            isEditDelete={isEditParamaters}
                          />
                        </Grid>)}
                    </>)}
                  {isAddVersion && !otaWithoutVersion && !rmwithoutVersion && (
                    <DialogActions className={style.buttonContainerEndAlign}>
                      <Button
                        variant="contained"
                        className={style.cancelButtonNew}
                        style={{ marginRight: "5px" }}
                        onClick={handleCancelAddVersion}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        className={style.saveButton}
                        onClick={handleAddVersion}
                      >
                        Update
                      </Button>
                    </DialogActions>)}
                </Grid>

              </>

            </Grid>

            <DialogActions>
              <Button
                variant="contained"
                className={style.cancelButtonNew}
                onClick={CancelUpdate}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                className={style.saveButton}

                disabled={isAddVersion && (!otaWithoutVersion && !rmwithoutVersion)}
                onClick={handleSave}
              >
                Update
              </Button>
            </DialogActions>
          </DialogContent>
        </>
      </Dialog>


      {addParameter || addCommand ? (
        // ***** This is add new parameter input filed set ***** //
        <>
          <Dialog open={addParameter || addCommand} maxWidth="md" fullWidth>
            <Grid container>
              <Grid item xs={10} md={10}>

                <DialogTitle>
                  {type === "view" ? "View" : type === "edit" ? "Edit" : "Add"}{" "}
                  {addParameter ? "Parameter" : addCommand ? "Command" : "Firmware"}
                </DialogTitle>

              </Grid>
              <Grid item xs={2} md={2} style={{ textAlign: "right" }}>
                <IconButton
                  onClick={() => {
                    addParameter ? closeAddParameter() : "";
                  }}
                >
                  <CloseIconColor />
                </IconButton>
              </Grid>
            </Grid>


            <DialogContent>
              {addParameter &&
                <Grid container style={{ textAlign: "center", marginTop: "20px" }}>
                  <Grid item xs={6} style={{ textAlign: "left", paddingBottom: "20px" }}>
                    <Typography className={style.typo}>Parameter name<span className={style.required}>*</span> </Typography>
                    <FormControl className={style.input}>
                      <DropDownRMOTA
                        isSingle={true}
                        options={allParameters}
                        type="parameter"
                        placeholder="Select Parameter Name"
                        value={type === "view" ? parameters[index] : {"parameter":parameter}}
                        setSelectValue={v => setParameter(v.target.value)}
                        disabled={type === "view"}
                        onClick={handleParameterSelect}
                        handleParameterCreate={handleParameterCreate}
                      />


                    </FormControl>
                    {parameterError.error && (
                      <Typography className={style.errorText}>{parameterError.errorMsg}</Typography>)}
                  </Grid>
                  <Grid item xs={6} md={6} style={{ textAlign: "left", paddingBottom: "20px", paddingLeft: "20px" }}>
                    <Typography className={style.typo}>Parameter ID<span className={style.required}>*</span></Typography>
                    <FormControl className={style.input}>

                      <input
                        className={style.formInputNew}
                        disabled={type === "view"}
                        type="number"
                        value={type === "view" ? parameters[index].parameterId : id}
                        onChange={(e) => {
                          setId(e.target.value);
                          setIdError({ error: false, errorMsg: "" });
                        }}
                      />

                    </FormControl>
                    {idError.error && (
                      <Typography className={style.errorText}>{idError.errorMsg}</Typography>)}
                  </Grid>
                  <Grid item xs={6} md={6} style={{ textAlign: "left", paddingBottom: "20px" }}>
                    <Typography className={style.typo}>Label<span className={style.required}>*</span></Typography>
                    <FormControl className={style.input}>
                      <input
                        className={style.formInputNew}
                        disabled={type === "view"}
                        value={type === "view" ? parameters[index].label : label}
                        onChange={(e) => {
                          setLabel(e.target.value);
                          setLabelError({ error: false, errorMsg: "" });
                        }}
                      />
                    </FormControl>
                    {labelError.error && (
                      <Typography className={style.errorText}>{labelError.errorMsg}</Typography>)}
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    md={6}
                    style={{ textAlign: "left", paddingBottom: "20px", paddingLeft: "20px" }}
                  >
                    <Typography className={style.typo}>Input Type<span className={style.required}>*</span></Typography>
                   <FormControl className={classes.input}>
                      <DropDownRMOTA
                        isSingle={true}
                        options={inputTypeOptions}
                        type="commandType"
                        placeholder="Select Input Type"
                        value={type === "view" ? parameters[index].inputType : inputType}
                        setSelectValue={(e) => setInputType(e.target.value)}
                        disabled={!(parameterToCreate || type == "edit")}
                        onClick={handleInputTypeSelect}

                      />
                       <Typography className={style.errorText}>{inputTypeError.errorMsg}</Typography>

                    </FormControl>
                  </Grid>
                  <Grid item xs={6} md={6} style={{
                    textAlign: "left", paddingBottom: "20px"
                  }}>
                    <Typography className={style.label}>Data format<span className={style.required}>*</span></Typography>
                                        <FormControl className={classes.input}>
                      <DropDownRMOTA
                        isSingle={true}
                        options={formatOptions}
                        type="commandType"
                        placeholder="Select Format Type"
                        value={type === "view" ? parameters[index].format : format}
                        setSelectValue={(e) => setFormat(e.target.value)}
                        disabled={!(parameterToCreate || type == "edit")}
                        onClick={handleFormatSelect}
                      />
                    </FormControl>
                    <Typography className={style.errorText}>{formatError.errorMsg}</Typography>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    md={6}
                    style={{ textAlign: "left", paddingBottom: "20px", paddingLeft: "20px" }}
                  >
                    <Typography className={style.label}>Default Value<span className={style.required}>*</span> &nbsp;
                    </Typography>
                    <FormControl className={style.input}>
                      <input
                        className={style.formInputNew}
                        disabled={type === "view" || format === ""}
                        onChange={(e) => {
                          setDefaultVal(e.target.value);
                          if (format == "Char" && e.target.value.length > 1) {
                            setDefaultValueError({ error: true, errorMsg: "Cannot add more than 1 character" })
                          }
                          else {
                            setDefaultValueError({ error: false, errorMsg: "" })
                          }
                        }}
                        value={
                          type === "view"
                            ? parameters[index].defaultValue
                            : defaultVal
                        }
                      />

                    </FormControl>
                    {defaultValueError.error && (
                      <Typography className={style.errorText}>
                        {defaultValueError.errorMsg}</Typography>
                    )}
                  </Grid>

                  <Grid item xs={12} md={12} style={{ textAlign: "left", paddingBottom: "20px" }}>
                    <Typography className={style.label}>Join Parameter</Typography>
                    <FormControl className={style.input}>
                      <Select
                        disabled={type === "view" ? true : false}
                        id="demo-customized-select-native"
                        value={
                          type === "view" ? parameters[index].joinParameter : join
                        }
                        className={style.input}
                        onChange={selectJoin}
                        multiple
                        MenuProps={{
                          anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                          },
                          transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                          },
                          getContentAnchorEl: null,
                        }}
                        renderValue={(selected: string[]) => (
                          <div>
                            {selected.map((value, i) => (
                              <Chip
                                key={i}
                                label={value}
                                className={style.chip}
                                onMouseDown={(event) => {
                                  event.stopPropagation();
                                }}
                                onDelete={() => removeJoin(value)}
                              />
                            ))}
                          </div>
                        )}
                        input={<BootstrapInput />}
                      >
                        {type === "add-new" ? (
                          parameters
                            .filter((obj) => obj.parameterCategory === mainType)
                            .map((p, j) => {
                              return (
                                <MenuItem value={p.parameterId} key={j}>
                                  <ListItemText
                                    primary={p.parameterId}
                                    style={{ color: primaryGray }}
                                  />
                                </MenuItem>
                              );
                            })
                        ) : type === "edit" ? (
                          parameters
                            .filter((obj) => obj.parameterCategory === mainType)
                            .filter((ob) => ob.parameterId !== parameters[index].parameterId)
                            .map((p, j) => {
                              return (
                                <MenuItem value={p.parameterId} key={j}>
                                  <ListItemText
                                    primary={p.parameterId}
                                    style={{ color: primaryGray }}
                                  />
                                </MenuItem>
                              );
                            })
                        ) : (
                          <div></div>
                        )}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>}

              {addCommand && (
                <Grid container style={{ textAlign: "center", marginTop: "20px" }}>
                  <Grid item xs={6} style={{ textAlign: "left", paddingBottom: "20px" }}>
                    <Typography className={style.typo}>Command name<span className={style.required}>*</span> </Typography>
                    {type === "edit" ? (

                      <input
                        disabled
                        className={style.formInputNew}
                        value={parameters[index].parameter}
                      />
                    ) :
                      <input
                        disabled={type === "add-new" ? false : true}
                        className={style.formInputNew}
                        onChange={(e) => setParameter(e.target.value)}
                        value={parameter}
                      />
                    }
                    {parameterError.error && (
                      <Typography className={style.errorText}>{parameterError.errorMsg}</Typography>)}
                  </Grid>
                  <Grid item xs={6} md={6} style={{ textAlign: "left", paddingBottom: "20px", paddingLeft: "20px" }}>
                    <Typography className={style.typo}>Command ID<span className={style.required}>*</span></Typography>
                    <FormControl className={style.input}>
                      {type === "edit" ? (
                        <Tooltip title="Parameter ID cannot be edited once saved" arrow>
                          <input
                            disabled
                            className={style.formInputNew}
                            type="number"
                            value={parameters[index].parameterId}
                          />
                        </Tooltip>
                      ) : (
                        <input
                          className={style.formInputNew}
                          disabled={type === "add-new" ? false : true}
                          type="number"
                          value={id}
                          onChange={(e) => {
                            setId(e.target.value);
                            setIdError({ error: false, errorMsg: "" });
                          }}
                        />
                      )}
                    </FormControl>
                    {idError.error && (
                      <Typography className={style.errorText}>{idError.errorMsg}</Typography>)}
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    md={6}
                    style={{ textAlign: "left", paddingBottom: "20px" }}
                  >
                    <Typography className={style.label}>Input Type<span className={style.required}>*</span></Typography>
                                        <FormControl className={classes.input}>
                      <DropDownRMOTA
                        isSingle={true}
                        options={inputTypeOptions}
                        type="commandType"
                        placeholder="Select Input Type"
                        value={type === "view" ? parameters[index].inputType : inputType}
                        setSelectValue={(e) => setInputType(e.target.value)}
                        disabled={type == "edit"}
                        onClick={handleInputTypeSelect}
                      />
                    </FormControl>
                    <Typography className={style.errorText}>{inputTypeError.errorMsg}</Typography>                      
                  </Grid>
                  <Grid item xs={6} md={6} style={{
                    textAlign: "left", paddingBottom: "20px", paddingLeft: "20px"
                  }}>
                    <Typography className={style.label}>Data format<span className={style.required}>*</span></Typography>
                    <FormControl className={classes.input}>
                      <DropDownRMOTA
                        isSingle={true}
                        options={formatOptions}
                        type="commandType"
                        placeholder="Select Format Type"
                        value={type === "view" ? parameters[index].format : format}
                        setSelectValue={(e) => setFormat(e.target.value)}
                        disabled={type == "edit"}
                        onClick={handleFormatSelect}

                      />
                    </FormControl>
                    <Typography className={style.errorText}>{formatError.errorMsg}</Typography>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    md={6}
                    style={{ textAlign: "left", paddingBottom: "20px" }}
                  >
                    <Typography className={style.label}>Command Value<span className={style.required}>*</span> &nbsp;
                      <Tooltip
                        arrow
                        title={
                          <React.Fragment>
                            <Grid container>
                              <Grid item xs={12} md={12}>
                                <Typography
                                  style={{ fontSize: "12px", color: '#FFFFFF', fontWeight: 300, fontFamily: 'poppins' }}
                                >{"Use curly braces {} to specify values that vary by device. For example, "}<br />
                                  {"S2D/SA/VA/{deviceId}"}
                                </Typography>
                              </Grid>
                            </Grid>
                          </React.Fragment>
                        }
                        interactive
                        placement="right"
                      >
                        <IconButton style={{ padding: "1px 2px 2px 0px" }}>
                          <QuestionIcon />
                        </IconButton>
                      </Tooltip>
                    </Typography>
                    <FormControl className={style.input}>
                      <input
                        className={style.formInputNew}
                        disabled={type === "view" || format === ""}
                        onChange={(e) => {
                          setDefaultVal(e.target.value);
                          if (format == "Char" && e.target.value.length > 1) {
                            setDefaultValueError({ error: true, errorMsg: "Cannot add more than 1 character" })
                          }
                          else {
                            setDefaultValueError({ error: false, errorMsg: "" })
                          }
                        }}
                        value={
                          type === "view"
                            ? parameters[index].defaultValue
                            : defaultVal
                        }
                      />

                    </FormControl>
                    {defaultValueError.error && (
                      <Typography className={style.errorText}>
                        {defaultValueError.errorMsg}</Typography>
                    )}
                  </Grid>
                  <Grid item xs={6} md={6} style={{
                    textAlign: "left", paddingBottom: "20px", paddingLeft: "20px"
                  }}>
                    <Typography className={style.label}>Command type<span className={style.required}>*</span></Typography>
                    <FormControl className={classes.input}>
                      <DropDownRMOTA
                        isSingle={true}
                        options={commandTypeOptions}
                        type="commandType"
                        placeholder="Select Command Type"
                        value={type === "view" ? parameters[index].commandType : commandType}
                        setSelectValue={(e) => setCommandType(e.target.value)}
                        disabled={type == "edit"}
                        onClick={handleCommandTypeSelect}

                      />
                    </FormControl>
                    <Typography className={style.errorText}>{commandTypeError.errorMsg}</Typography>
                  </Grid>


                </Grid>

              )}
            </DialogContent>
            {type !== "view" && (
              <DialogActions style={{ width: "100%" }} hidden>
                <Button
                  variant="contained"
                  className={style.cancel}
                  onClick={closeAddParameter}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  className={style.add}
                  disabled={type === "view" ? true : false}
                  onClick={() => {

                    readParameters({
                      parameterCategory: mainType,
                      parameter: parameter,
                      parameterId: id,
                      inputType: inputType,
                      format: format,
                      joinParameter: join,
                      defaultValue: defaultVal,
                      label: label,
                      isCommand: addCommand ? true : false,
                      commandType: commandType
                    });
                  }}
                >
                  {type === "edit" ? "Update" : "Save"}
                </Button>
              </DialogActions>
            )}
          </Dialog>
        </>
      ) : ""}

      {loadingScreen &&
        <div style={{
          position: 'fixed',
          left: 0,
          top: 0,
          backgroundColor: '#000000',
          opacity: 0.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
          width: '100vw',
          height: '100vh'
        }}>
          <CircularProgress size={80} />
        </div>}
      <Snackbar
        open={open}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert severity={reqSuccess === true ? "success" : "warning"}>
          <h3 style={{ textAlign: "left" }}>
            {reqSuccess === true ? "Success" : "Error"}
          </h3>
          {reqSuccess
            ? (successMessage.length > 0 ? successMessage : "Success")
            : errorMessage.length > 0
              ? errorMessage
              : "Something Went Wrong"}
        </Alert>
      </Snackbar>
      <AlertDialog openDialog={openDelete} setOpenDialog={setOpenDelete} handleSkip={handleDeleteParameter} OKText={"Delete"} severity={"danger"} title={"Confirm Delete?"} description={"Are you sure you want to remove this parameter ?"} />
      <PromptDialog openDialog={openPrompt} setOpenDialog={setOpenPrompt} OKText={"Ok"} title={"Device Configuration Needed"} description={topicError} />
      <ConfirmPopup
        open={openEditParamLabel}
        closePopup={handleCloseParamLabelEdit}
        handleConfirm={handleConfirmEditParamLabel}
        handleDiscardConfirm={handleCloseParamLabelEdit}
        title={"Confirm update parameter template"}
        info={"Parameter template will also be editted with this action.Are you sure want to continue?"}
        type={"labelEdit"}
      />
      <ConfirmPopup open={openConfirmDialog} handleConfirm={handleDiscardParamChange} closePopup={handleCancelToggle}   handleDiscardConfirm={handleCancelToggle} title={confirmDialogTitle} info={confirmDialogDescription} type={'discardUpdate'} />

      <UpgradePopup
        open={upgradePopup.open}
        onClose={() => setUpgradePopup({ ...upgradePopup, open: false })}
        onUpgrade={() => {
          setUpgradePopup({ ...upgradePopup, open: false });
          window.open(environment.azurepageLink);
        }}
        featureName={upgradePopup.featureName}
        onCloseWithFeature={() => {
          setUpgradePopup({ ...upgradePopup, open: false });
          if (upgradePopup.featureName === 'Remote Manager') {
            setUpdatedRemotelyConfigurable(!updatedRemotelyConfigurable);
          } else if (upgradePopup.featureName === 'OTA') {
            setUpdatedOtaUpgradable(!updatedOtaUpgradable)
          }
        }}
      />
    </div>
  );
};
export default function PromptDialog(props) {
  const buttonColor = props.severity && props.severity == "danger" ? primaryRed : primaryBlue;

  const handleClose = () => {

    props.setOpenDialog(false);
  }
  return (
    <Dialog
      open={props.openDialog}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {props.title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {props.description}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} style={{ backgroundColor: buttonColor, color: "white" }}>{props.OKText ? props.OKText : "OK"}</Button>
      </DialogActions>
    </Dialog>)
}
const useLocalStyles = makeStyles((theme: Theme) => ({
  container: {
    paddingTop: "20px",
  },
  input: {
    width: "100%",
    textAlign: "left",
  },
  labelStyle: {
    fontFamily: "Poppins",
    fontSize: "15px",
    lineHeight: "25px",
  },
  greyLabel: {
    color: "#707070"
  },
  textBarStyle: {
    height: "38px",
    borderRadius: "5px",
    border: "1px solid black",
  },
  popup: {
    backgroundColor: "#CEEBCE",
  },
  formInput: {
    height: "38px",
    borderRadius: "5px",
    padding: "10px 15px",
    fontFamily: "'Poppins', sans-serif",
    border: '0.5px solid',
    backgroundColor: white,
    fontSize: "13px",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer'
  },
  configDevicesButton: {
    backgroundColor: white,
    color: primaryBlue,
    borderColor: primaryBlue,
    borderStyle: "solid",
    borderWidth: "1px",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: primaryBlue,
      color: white,
      boxShadow: "none",
    },
  },
  gridStyle: {
    textAlign: "left",
    marginBottom: "25px",
    paddingRight: "2%",
  },
  dropdown: {
    textAlign: 'left',
    border: '0.5px solid #324054',
    margin: 'px',
    borderRadius: '5px',
    backgroundColor: white,
    width: '100%',
    zIndex: 1,
    maxHeight: '160px',
    overflowY: 'auto',
  },
  option: {
    paddingLeft: '10px',
    height: '30px',
    "&:hover": {
      backgroundColor: primaryBlue,
      color: white,
      boxShadow: "none",
    },
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    fontSize: "13px"
  },
  dropDownGrid: {
    backgroundColor: white,
    border: '1px solid #C7C4C4',
    borderRadius: '5px',
    maxHeight: '200px',
    overflowY: 'auto',
    marginTop: '40px',
    zIndex: 10,
    position: 'absolute'
  },
  addIcon: {
    margin: "5px 0px 0px 10px",
    alignItems: 'center',
    cursor: 'pointer'
  },
  /* Frame 1000004062 */
  deviceList: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    padding: "10px 10px 10px 20px",
    width: "100%",
    height: "56px",
    background: "#FFFFFF",
    border: "0.5px solid #C7C4C4",
    borderRadius: "4px",
  },

  deviceLeft: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    gap: "11px",
    margin: "0px"
  },
  fileContainer: {
    display: "flex",
    flexDirection: "row",
    gap: "11px",
    margin: "0px",
    width: "100%",
    alignItems: "center"
  },
  shadowedbox: {
    justifyContent: "flex-start", display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "12px",
    boxSizing: "border-box",
    background: "#FFFFFF",
    border: "0.5px solid #C7C4C4",
    borderRadius: "4px",
    padding: "10px",
    width: "40%",
    minWidth: "250px",
    marginLeft: "0px"
  }
  ,
  deviceChip: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "8px 13px",
    gap: "12px",
    width: "120px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    height: "36px",
    background: "#FFFFFF",
    border: "1px solid #E2E5ED",
    borderRadius: "6px",
  },

  /* Placeholder text */
  chipText: {
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "20px",
    display: "flex",
    alignItems: "center",
    color: "#324054",
  },
  fileContent: { height: "100%", display: "flex", alignItems: "center", width: "80%" }
}));


const BootstrapInput = withStyles((theme: Theme) =>
  createStyles({
    root: {
      "label + &": {
        marginTop: theme.spacing(3),
      },
    },

    input: {
      borderRadius: 4,
      position: "relative",
      backgroundColor: "white",
      border: "1px solid #ced4da",
      fontSize: 16,
      padding: "10px 26px 10px 12px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),
      "&:focus": {
        borderRadius: 4,
        borderColor: searchBarBorderColor,
        backgroundColor: "white",
      },
    },

  })
)(InputBase);

export function DeviceListItem({ deviceName, styles }) {
  return (

    <div className={styles.deviceLeft}>
      <div className={styles.deviceChip}>
        <span className={styles.chipText}>{deviceName}</span>
      </div>
    </div>

  );
}